module.exports = __webpack_public_path__ + "static/media/03-2-galeria-02-tory-burch@2x.36ea74b6.jpg";